import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import bookingChangesApi from '@/features/dashboard/bookingChanges/api/bookingChangesApi.ts';
import { bookingChangesApiQueryKeys } from '@/features/dashboard/bookingChanges/api/bookingChangesApi.queryKeys.ts';
import { AcceptBookingChangeRequest } from '@/features/dashboard/bookingChanges/types/dto/AcceptBookingChangeRequest.ts';

interface AcceptPublicChangeParams {
  changeId: string;
  request: AcceptBookingChangeRequest;
}

/**
 * Akceptacja zmian przez osobę zapisującą (krok W3).
 *
 * `expectedAdditionalPayment` musi być kwotą pokazaną na stronie — rozjazd
 * z kwotą serwera kończy się błędem `error.booking.price_changed`.
 *
 * Woła go panel zmian na podsumowaniu rezerwacji (`PendingChangeSection`) —
 * jedyne miejsce, w którym decyzję podejmuje zapisujący. Krok W3 w panelu
 * operatora zostaje wyłącznie podglądem tej strony i przycisków decyzji nie ma.
 */
const useAcceptPublicChange = (orgSlug: string, token: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ changeId, request }: AcceptPublicChangeParams) =>
      bookingChangesApi.acceptPublicChange(orgSlug, changeId, token, request),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: bookingChangesApiQueryKeys.publicChange(orgSlug, token),
      });
      toast.success('Zmiany zostały zaakceptowane');
    },
    onError: (error: Error) => {
      toast.error('Nie udało się zaakceptować zmian', {
        description: error.message,
      });
    },
  });
};

export default useAcceptPublicChange;
